import React from 'react'

import { useNavigate } from 'react-router-dom'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { Button, ThemeProvider } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Header from '../../../components/header/Header'
import styles from '../Rewards.module.scss'
import { coupons, getRandomValue } from '../components/Categories'
import theme from '../../../theme/theme'

export default function Rewarded() {
  const getStatus = (params: any) => {
    switch (params.row.status) {
      case 'DISPONÍVEL':
        return (
          <div className={`${styles.availableRewarded}`}>
            <div className={styles.text}>
              <small>DISPONÍVEL</small>
            </div>
          </div>
        )
      case 'RESGATADO':
        return (
          <div className={`${styles.warningRewarded}`}>
            <div className={styles.text}>
              <small>RESGATADO</small>
            </div>
          </div>
        )
      case 'EXPIRADO':
        return (
          <div className={`${styles.errorRewarded}`}>
            <div className={styles.text}>
              <small>EXPIRADO</small>
            </div>
          </div>
        )

      default:
        return params.row.status
    }
  }
  const columns: GridColDef[] = [
    {
      field: 'category',
      headerName: 'Categoria',
      headerAlign: 'center',
      align: 'center',
      flex: 1
    },
    {
      field: 'discountType',
      headerName: 'Benefício',
      flex: 1,
      sortable: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'establishment',
      headerName: 'Estabelecimento',
      sortable: true,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      minWidth: 120
    },
    {
      field: 'city',
      headerName: 'Localização',
      sortable: true,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      minWidth: 120
    },
    {
      field: 'validity',
      headerName: 'Validade',
      sortable: true,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      maxWidth: 110
    },
    {
      field: 'rewarded',
      headerName: 'Resgatado',
      sortable: true,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      maxWidth: 110
    },
    {
      field: 'status',
      headerName: 'STATUS',
      flex: 1,
      headerAlign: 'center',
      maxWidth: 110,
      sortable: true,
      align: 'center',
      renderCell: getStatus
    }
  ]
  const navigate = useNavigate()

  return (
    <div className={styles.rewards}>
      <Header />
      <div className={styles.rewardsWrapper}>
        <div className="d-flex flex-column align-items-center w-100">
          <h4>MEUS RESGATES</h4>
          <h5>{`Você já resgatou R$ ${getRandomValue(50, 150)},00`}</h5>
        </div>
        <hr />
        <div className={styles.categoriesTableWrapper}>
          <ThemeProvider theme={theme}>
            <div className={styles.grid}>
              <DataGrid
                sx={{ fontSize: 48 }}
                rows={coupons}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 6
                    }
                  }
                }}
                density="comfortable"
                pageSizeOptions={[10, 15, 25, 50, 100]}
                disableRowSelectionOnClick
              />
            </div>
          </ThemeProvider>
        </div>
        <div className="d-flex flex-column align-items-center">
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate('/rewards')}
            className="text-center mt-3"
          >
            <ArrowBackIcon fontSize="small" className="me-2" />
            {` VOLTAR`}
          </Button>
        </div>
      </div>
    </div>
  )
}
